//Estilos
import './styles/splash.css'

//Extras
import { main } from '../assets/extras'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Splash = (props) => {

    document.title = "Tenista Dashboard"

    const navigate = useNavigate()

    useEffect(() => {
        setTimeout(() => {
            navigate("/login")
        }, 1000)
    }, [])

    return (
        <div class="background" style={{ backgroundColor: main }}>

        </div>
    )
}

export default Splash